// Register user
export const CREATE_USER = 'CREATE_USER'
export const CREATE_USER_PENDING = `${CREATE_USER}_PENDING`
export const CREATE_USER_FULFILLED = `${CREATE_USER}_FULFILLED`
export const CREATE_USER_REJECTED = `${CREATE_USER}_REJECTED`

// check if username exists
export const USERNAME_NOT_EXISTS_USER = 'USERNAME_NOT_EXISTS_USER'
export const USERNAME_NOT_EXISTS_USER_PENDING = `${USERNAME_NOT_EXISTS_USER}_PENDING`
export const USERNAME_NOT_EXISTS_USER_FULFILLED = `${USERNAME_NOT_EXISTS_USER}_FULFILLED`
export const USERNAME_NOT_EXISTS_USER_REJECTED = `${USERNAME_NOT_EXISTS_USER}_REJECTED`

export const PHONE_NOT_EXISTS_USER = 'PHONE_NOT_EXISTS_USER'
export const PHONE_NOT_EXISTS_USER_PENDING = `${PHONE_NOT_EXISTS_USER}_PENDING`
export const PHONE_NOT_EXISTS_USER_FULFILLED = `${PHONE_NOT_EXISTS_USER}_FULFILLED`
export const PHONE_NOT_EXISTS_USER_REJECTED = `${PHONE_NOT_EXISTS_USER}_REJECTED`

export const RETRIEVE_USER_FROM_TOKEN = 'RETRIEVE_USER_FROM_TOKEN'
export const RETRIEVE_USER_FROM_TOKEN_PENDING = `${RETRIEVE_USER_FROM_TOKEN}_PENDING`
export const RETRIEVE_USER_FROM_TOKEN_FULFILLED = `${RETRIEVE_USER_FROM_TOKEN}_FULFILLED`
export const RETRIEVE_USER_FROM_TOKEN_REJECTED = `${RETRIEVE_USER_FROM_TOKEN}_REJECTED`

export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_PENDING = `${LOGIN_USER}_PENDING`
export const LOGIN_USER_FULFILLED = `${LOGIN_USER}_FULFILLED`
export const LOGIN_USER_REJECTED = `${LOGIN_USER}_REJECTED`

export const GENERATE_TOKEN_PASSWORD = 'GENERATE_TOKEN_PASSWORD'
export const GENERATE_TOKEN_PASSWORD_PENDING = `${GENERATE_TOKEN_PASSWORD}_PENDING`
export const GENERATE_TOKEN_PASSWORD_FULFILLED = `${GENERATE_TOKEN_PASSWORD}_FULFILLED`
export const GENERATE_TOKEN_PASSWORD_REJECTED = `${GENERATE_TOKEN_PASSWORD}_REJECTED`

export const VERIF_TOKEN_PASSWORD = 'VERIF_TOKEN_PASSWORD'
export const VERIF_TOKEN_PASSWORD_PENDING = `${VERIF_TOKEN_PASSWORD}_PENDING`
export const VERIF_TOKEN_PASSWORD_FULFILLED = `${VERIF_TOKEN_PASSWORD}_FULFILLED`
export const VERIF_TOKEN_PASSWORD_REJECTED = `${VERIF_TOKEN_PASSWORD}_REJECTED`

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_PENDING = `${CHANGE_PASSWORD}_PENDING`
export const CHANGE_PASSWORD_FULFILLED = `${CHANGE_PASSWORD}_FULFILLED`
export const CHANGE_PASSWORD_REJECTED = `${CHANGE_PASSWORD}_REJECTED`


export const LOGOUT_USER = 'LOGOUT_USER'


// WEBPACK FOOTER //
// ./src/user/UserConstants.js